(ns frontend.ui.component.lp-portal.checkbox.style
  (:require
   [frontend.ui.style.theme.core :refer [color]]
   [frontend.ui.style.theme.core :as theme]
   [garden.util :refer [space-join]]))

(defn checkbox-unchecked
  []
  {:min-width     "16px!important"
   :height        "16px!important"
   :width         "16px!important"
   :border-radius :3px
   :border        (space-join ["2px solid" (theme/color [:checkbox :regular-label :disabled])])
   :user-select   :none})

(defn checkbox-checked
  []
  {:min-width   "16px!important"
   :min-height  "16px!important"
   :width       "16px!important"
   :height      "16px!important"
   :line-height :18px
   :font-size   :18px
   :user-select :none})

(defn size
  [size-px]
  (let [size-string (str size-px "px")]
    {:width      size-string
     :height     size-string
     :min-width  size-string
     :min-height size-string}))
